import { render, staticRenderFns } from "./ExamInfoSide.vue?vue&type=template&id=6245177d&scoped=true"
import script from "./ExamInfoSide.vue?vue&type=script&lang=js"
export * from "./ExamInfoSide.vue?vue&type=script&lang=js"
import style0 from "./ExamInfoSide.vue?vue&type=style&index=0&id=6245177d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0___a965578a4a18db21b1dac13b221d5bdb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6245177d",
  null
  
)

export default component.exports